export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
];

export const COMPANY = {
  name: "Laronta Pro Tax Services LLC",
  shortName: "Laronta Pro Tax",
  phone: "(385) 424-6444",
  phoneHref: "tel:+13854246444",
  email: "officedesk@larontaprotaxservices.com",
  emailHref: "mailto:officedesk@larontaprotaxservices.com",
  address: "5993 Redwood Road",
  city: "Taylorsville",
  state: "UT",
  zip: "84123",
  fullAddress: "5993 Redwood Road, Taylorsville, UT 84123",
  hours: [
    { days: "Monday – Friday", time: "9:00 AM – 5:00 PM" },
    { days: "Saturday – Sunday", time: "Closed" },
  ],
  images: {
    hero: "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
    office: "https://images.pexels.com/photos/3747070/pexels-photo-3747070.jpeg",
    team: "https://images.pexels.com/photos/7654609/pexels-photo-7654609.jpeg",
    intake: "https://images.unsplash.com/photo-1521791055366-0d553872125f",
    tax: "https://images.unsplash.com/photo-1586486855514-8c633cc6fd38",
  },
};
